import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import makeComponentTrashable from 'trashable-react';
import { useStatusMessage, useTranslation } from 'Shared/util/custom-hooks';
import { updatePasswordLoggedIn } from 'Shared/util/web-api';
import { joinClassNames as c } from 'Shared/util/styles';
import StatusMessage from 'Shared/components/status-message';
import ReturnTitle from 'Shared/components/return-title';
import InputText from 'Shared/components/input-text';
import Button from 'Shared/components/button';
import tabStyles from './tab.css';
import styles from './change-password-tab.css';


const ChangePasswordTab = ({
  registerPromise,
  display,
  onHide,
}) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validCurrentPassword, setValidCurrentPassword] = useState('');
  const [validNewPassword, setValidNewPassword] = useState('');
  const [validConfirmPassword, setValidConfirmPassword] = useState('');
  const [statusMessage, dispatchStatusMessage] = useStatusMessage();
  const t = useTranslation(x => x.userEdit);
  const tg = useTranslation(x => x.global);

  const handleChangePassword = (e) => {
    registerPromise(updatePasswordLoggedIn(newPassword, confirmPassword, currentPassword))
      .then(() => dispatchStatusMessage({ type: 'SUCCEEDED', message: t.yourPasswordHasBeenUpdated }))
      .catch(() => dispatchStatusMessage({ type: 'FAILED', message: t.yourPasswordCouldNotBeUpdated }));

    e.preventDefault();
  };

  const resetFields = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    dispatchStatusMessage({ type: 'NONE' });
  };

  useEffect(() => {
    if (!display) {
      resetFields();
    }
  }, [display]);

  const isSubmitEnabled = (validCurrentPassword && validNewPassword && validConfirmPassword);

  return (
    <div className={c(tabStyles.container, (display ? tabStyles.visible : tabStyles.hidden))}>
      <StatusMessage
        status={statusMessage.type}
        text={statusMessage.message}
        clearStatus={() => dispatchStatusMessage({ type: 'NONE' })}
        className={styles.statusMessageContainer}
      />
      <ReturnTitle
        title={t.changePassword}
        onClick={onHide}
        display
      />
      <form
        className={tabStyles.content}
        onSubmit={(e) => handleChangePassword(e)}
      >
        <InputText
          inputType="current-password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          setEnabledSubmit={(bool) => setValidCurrentPassword(bool)}
          isRequired
        />
        <InputText
          inputType="new-password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          setEnabledSubmit={(bool) => setValidNewPassword(bool)}
          isRequired
        />
        <InputText
          inputType="confirm-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          setEnabledSubmit={(bool) => setValidConfirmPassword(bool)}
          compareValue={newPassword}
          isRequired
        />
        <div className={tabStyles.buttonsContainer}>
          <Button
            buttonType="button-secondary"
            text={tg.cancel}
            onClick={onHide}
          />
          <Button
            text={t.changePassword}
            attributes={{
              type: 'submit',
              disabled: !isSubmitEnabled,
            }}
            className={tabStyles.submitButton}
          />
        </div>
      </form>
    </div>
  );
};

ChangePasswordTab.propTypes = {
  registerPromise: PropTypes.func.isRequired,
  display: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default makeComponentTrashable(ChangePasswordTab);
